import React, { useState } from 'react';
import {
  Dialog, DialogContent, DialogTitle, IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelConfirm from './CancelConfirm';

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {boolean} props.open
 * @param {React.ReactNode} props.children
 * @param {Function} props.onClose
 * @param {boolean} props.dirty
 */
export default function ConfirmDialog({
  title, open, children, onClose, dirty,
}) {
  const [confirmClose, setConfirmClose] = useState(false);

  return (
    <>
      <Dialog fullWidth maxWidth="md" open={open}>
        <DialogTitle>{title}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            if (dirty) setConfirmClose(true);
            else onClose();
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'grey.500',
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ padding: 0 }}>
          {children}
        </DialogContent>
      </Dialog>
      <CancelConfirm
        open={confirmClose}
        title="Are you sure you want to close?"
        text="You have unsaved changes. Any unsaved data will be lost."
        cancelText="Resume Changes"
        confirmText="Abandon Changes"
        onCancel={() => setConfirmClose(false)}
        onConfirm={() => {
          setConfirmClose(false);
          onClose();
        }}
      />
    </>
  );
}
